import { useState } from "react";
import { FiExternalLink } from "react-icons/fi";
import { IoIosArrowForward, IoIosArrowDown } from "react-icons/io";
import { FaGithub } from "react-icons/fa";

interface tech {
  name: string;
  icon: string;
}
interface projectData {
  data: {
    name: string;
    description: string;
    image: string;
    github: string;
    url: string;
    tech: tech[];
    fullDescription: string;
  };
}

export default function ProjectItem(props: projectData) {
  const [show, setShow] = useState<boolean>(false);
  const { name, description, image, github, url, tech, fullDescription } =
    props.data;

  const toggleShow = (): void => {
    setShow(!show);
  };

  return (
    <div className="flex mb-8 justify-between gap-3 gap-y-4">
      <div>
        <h5 className="font-bold flex items-center mb-2 dark:text-dark_text">
          {name}{" "}
          <a
            href={url}
            className="ml-2 mr-3 text-primary text-xl"
            target="_blank"
            rel="noreferrer"
          >
            <FiExternalLink />
          </a>
          <a
            href={github}
            className="text-primary text-xl"
            target="_blank"
            rel="noreferrer"
          >
            <FaGithub />
          </a>
        </h5>
        <p className="text-subText font-medium dark:text-white max-w-sm">
          {description}
        </p>
        <button
          onClick={toggleShow}
          className="flex font-semibold mt-2 items-center text-primary cursor-pointer"
        >
          See more{" "}
          {show ? (
            <IoIosArrowDown className="ml-1" />
          ) : (
            <IoIosArrowForward className="ml-1" />
          )}
        </button>

        {show && (
          <div className="mt-3">
            <p className="text-subText font-medium dark:text-white max-w-sm">
              {fullDescription}
            </p>
            <div className="flex flex-wrap gap-2 mt-3">
              {tech.map((item, i) => (
                <span
                  key={i}
                  className="bg-grey flex items-center text-sm px-2 py-1 dark:bg-dark_bg dark:text-dark_text font-medium rounded-md"
                >
                  <img
                    src={item.icon}
                    alt="icon"
                    className="lazyload w-4 h-4 mr-2"
                  />{" "}
                  {item.name}
                </span>
              ))}
            </div>
          </div>
        )}
      </div>
      <div>
        <img
          className="lazyload rounded-md object-none"
          data-src={image}
          alt="project thumbnail"
        />
      </div>
    </div>
  );
}
